"use strict";
var isKeyable = require('./_isKeyable');
function getMapData(map, key) {
    var data = map.__data__;
    return isKeyable(key)
        ? data[typeof key == 'string' ? 'string' : 'hash']
        : data.map;
}
module.exports = getMapData;
//# sourceMappingURL=_getMapData.js.map